<template>
  <div class="text-center">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          class="mx-1"
          fab
          dark
          x-small
          max-height="32"
          max-width="32"
          color="success"
          outlined
          icon
          @click.prevent="getLinkWhastapp(phone, messageToSend)"
        >
          <v-img
            :src="require('@/assets/WhatsApp.svg')"
            contain
            max-height="28"
            max-width="28"
          ></v-img>
        </v-btn>
      </template>
      <span>Falar com representante</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WhatsApp-button',
  props: {
    messageToSend: {
      type: String,
      default: 'Olá, preciso de ajuda.',
    },
    phone: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState('systemModule', ['system']),
  },
  methods: {
    getLinkWhastapp(number, message) {
      if (!number) number = this.system.WHATSAPP ?? process.env.VUE_APP_WHATSAPP

      var url =
        'https://api.whatsapp.com/send?phone=' +
        number +
        '&text=' +
        encodeURIComponent(message)
      window.open(url, '_blank').focus()
    },
  },
}
</script>

<style lang="scss" scoped></style>
